module.exports = __webpack_public_path__ + "6fb2eb6aea8967160c063317759fd5af.pdf";